import { styled, Box } from "@mui/material";

export const ReferenceBookGroup = styled(Box)(({ theme }) => ({
  display: "flex",
  flexWrap: "wrap",
  gap: "1.25rem",
  mb: "0.7rem",
}));
